import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06ec4100"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "all-jobs" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "search-form" }
const _hoisted_5 = { class: "search-form-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-form-item-label" }, "日期", -1))
const _hoisted_7 = { class: "search-form-item-content" }
const _hoisted_8 = { class: "search-form-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-form-item-label" }, "縣市", -1))
const _hoisted_10 = { class: "search-form-item-content" }
const _hoisted_11 = { class: "price-type-buttons" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("收費")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("互惠")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 展開搜尋 ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "body f-scroll" }
const _hoisted_17 = { class: "jobs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_down_outlined = _resolveComponent("down-outlined")!
  const _component_JobListItemPublic = _resolveComponent("JobListItemPublic")!
  const _component_JobDetailVue = _resolveComponent("JobDetailVue")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["search-field", { 'search-field--show': _ctx.showSearchField }])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_a_range_picker, {
                    value: _ctx.searchForm.range,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.range) = $event)),
                    "allow-clear": "",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fetchAllJobs(1))),
                    style: {"width":"100%"}
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_a_select, {
                    value: _ctx.searchForm.city,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.city) = $event)),
                    placeholder: "縣市",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fetchAllJobs(1))),
                    "allow-clear": "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities, (city, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: index
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(city), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ])
          ], 2), [
            [_vShow, _ctx.showSearchField]
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_a_button, {
              class: "price-type-button",
              shape: "round",
              type: _ctx.searchForm.type === 1 ? 'primary' : '',
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setSearchFormType(1)))
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["type"]),
            _createVNode(_component_a_button, {
              class: "price-type-button",
              shape: "round",
              type: _ctx.searchForm.type === 2 ? 'primary' : '',
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setSearchFormType(2)))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["type"])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_a_button, {
            type: "text",
            style: {"height":"auto"},
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showSearchField = !_ctx.showSearchField))
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _hoisted_15,
              _createVNode(_component_down_outlined)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allJobs, (job) => {
            return (_openBlock(), _createBlock(_component_JobListItemPublic, {
              job: job,
              key: job.id
            }, null, 8, ["job"]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isQueryJobVisible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isQueryJobVisible) = $event)),
      footer: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_JobDetailVue, { trackingNumber: _ctx.queryJobTrackingNumber }, null, 8, ["trackingNumber"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}